import PartnerProduct from '../../domains/PartnerProduct'
import PubSub from '../PubSub'

interface PartnerState {
  openEmailInputModal: boolean
  openLoadingModal: boolean
  partnerPDPModal: boolean
  partnerProduct?: PartnerProduct
  source: string
  tracker?: string
}

class PartnerModalStateManager extends PubSub {
  private state: PartnerState
  constructor() {
    super()
    this.state = {
      openEmailInputModal: false,
      openLoadingModal: false,
      partnerPDPModal: false,
      source: '',
      tracker: '',
    }
  }
  setOpenEmailInputModal = (open: boolean) => {
    this.state.openEmailInputModal = open
    this.publish()
  }
  setOpenLoadingModal = (open: boolean) => {
    this.state.openLoadingModal = open
    this.publish()
  }
  setPartnerPDPModal = (open: boolean) => {
    this.state.partnerPDPModal = open
    this.publish()
  }
  setPartnerProduct = (partnerProduct: PartnerProduct) => {
    this.state.partnerProduct = partnerProduct
    this.publish()
  }

  setPopupTracker = (tracker: string) => {
    this.state.tracker = tracker
    this.publish()
  }

  setSource = (source: string) => {
    this.state.source = source
    this.publish()
  }
  getPartnerProduct = () => {
    return this.state.partnerProduct
  }
  getPartnerPDPModal = () => {
    return this.state.partnerPDPModal
  }
  getOpenEmailInputModal = () => {
    return this.state.openEmailInputModal
  }
  getOpenLoadingModal = () => {
    return this.state.openLoadingModal
  }
  getSource = () => {
    return this.state.source
  }
  getPopupTracker = () => {
    return this.state.tracker
  }
}

const partnerModalStateManager: PartnerModalStateManager = PartnerModalStateManager.getInstance(
  'PartnerModalStateManager',
) as PartnerModalStateManager

export default partnerModalStateManager
